<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label for="form-pass-cause" class="control-label">{{ inputLabel }}</label>
    <select
        v-model="inputValue"
        id="form-pass-cause"
        class="form-control"
        :disabled="disabled || this.disabledCondition"
        @input="emit"
        @change="emit; deleteVessels()"
        @blur="emit"
    >
      <option v-for="purpose in availableItems" v-bind:key="purpose.id" :value="purpose.id">{{ purpose.name }}</option>
    </select>

    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'
import { VesselAccesses as VesselAccessesEnum } from '@/common/enums/VesselAccesses'
import { PurposeNeedVesselTypes } from '@/common/enums/PurposeNeedVesselTypes'

export default {
  name: 'VesselAccessInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Заход на борт судов'
    },

    inputName: {
      default: 'vessel_access'
    },

    items: {
      type: [Array, Object],
      default: () => []
    },

    applicationPurposes: {}
  },

  created() {
    let currentValue = this.items.find((item) => item.id === this.inputValue)

    if (this.isDuplicate && Number(currentValue.visible) === 0) {
      this.inputValue = this.availableItems[0]?.id
    }
  },

  methods: {
    deleteVessels() {
      this.form.vessels = []
    }
  },

  computed: {
    disabledCondition() {
      return this.availableItems.length === 1
    },

    availableItems() {
      if (this.isView) {
        return this.items
      }
      let arr = this.items.filter((item) => Number(item.visible) === 1)
      let currentPurpose = this.applicationPurposes[this.form.application.application_group_purpose_id]
      if (Number(currentPurpose.need_vessel) === PurposeNeedVesselTypes.FORBIDDEN_VESSEL) {
        return arr.filter((item) => item.id === VesselAccessesEnum.WITHOUT_VESSEL)
      }

      if (Number(currentPurpose.need_vessel) === PurposeNeedVesselTypes.NEED_VESSEL) {
        return arr.filter((item) => item.id !== VesselAccessesEnum.WITHOUT_VESSEL)
      }

      return arr
    }
  },

  watch: {
    items (items) {
      if (items.length === 1) {
        this.inputValue = items[0]?.id
      }
    }
  }
}
</script>
